import client from "./client";
import keyFactory from "./keyFactory";

export const createCodeSystemByURLQuery = (url: string) => ({
  queryKey: keyFactory.allCodeSystems({ url }),
  queryFn: () => client.r5.getAllCodeSystemsR5({ url }),
  staleTime: 3600 * 1000,
});
